module.exports = __webpack_public_path__ + "static/media/gcash-logo.b701ac17.png";